module.exports = __webpack_public_path__ + "img/building-2_fill.618b0a6b.svg";